export enum DisplayStatus {
    Display = 'DISPLAY',
    Hide = 'HIDE',
    Scheduled = 'SCHEDULED',
};